import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { ButtonComponent, IconComponent, ResolvableModal, TranslatePipe } from '@softline/ui-core';
import { Bewe } from '../../types/bewegung';
import { PaletteBean } from '../../types/pallet-item';

@Component({
  selector: 'soft-pallet-summary-dialog',
  imports: [DecimalPipe, ButtonComponent, IconComponent, TranslatePipe],
  templateUrl: './pallet-summary-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PalletSummaryDialogComponent extends ResolvableModal<boolean> {
  readonly bewe = input.required<Bewe>();
  readonly pallets = input.required<PaletteBean[]>();
  readonly expectedQuantity = input.required<number>();
  readonly unit = input<string | undefined>();

  readonly total = computed(() =>
    this.pallets().reduce((sum, pallet) => sum + (pallet.menge ?? 0), 0)
  );
  readonly difference = computed(() => this.total() - this.expectedQuantity());
}
